import React from 'react';
import { Popconfirm, Tooltip, Dropdown, Menu, notification } from 'antd';
import { EditOutlined, CopyOutlined, LoadingOutlined, CaretDownOutlined } from '@ant-design/icons';
import { useHistory, useParams } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import Crown from '@Images/crown2.png';
import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';
// FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
// UI Components
import H3Text from '@Uilib/h3Text';

// style
import './style.scss';

const ViewPrHeader = ({
  selectedPurchaseRequest,
  user,
  isQuickView,
  updatePurchaseRequestStatus,
  deletePurchaseRequest,
  getPurchaseRequestById,
  updatePurchaseRequestStatusLoading,
  deletePurchaseRequestLoading,
  currentUpdate,
  setCurrentUpdate,
  setSendForApprovalConfirmation,
  setShowNewStForm,
  setShowCreateRfqDrawer,
  setShowPIForm,
  downloadDocument,
  match,
}) => {
  const history = useHistory();
  const currentPrId = selectedPurchaseRequest?.purchase_requisition_id;

  const handleDownload = () => {
    downloadDocument({
      url: `${Constants.PURCHASE_REQUESTS}/download?pr_id=${selectedPurchaseRequest?.purchase_requisition_id}`,
      document_type: 'PURCHASE_REQUEST',
      document_number: selectedPurchaseRequest?.pr_number,
      key: uuidv4(),
    });
  };

  // If User is from store person user can see PR.
  // User should be either form Issues department or Requester department.
  // If user is from store or Issuer department then he can create PO and ST.
  const isIssuerDepartmentAccessible = (record) => {
    const tenantId = record?.issuer_tenant_id ? record?.issuer_tenant_id : record?.tenant_id;
    const { userTenantDepartmentId, tenantDefaultStoreId } = Helpers.getUserTenantDepartmentIds(user, tenantId);

    return (
      record?.issuer_tenant_department_id == userTenantDepartmentId || record?.issuer_tenant_department_id == null || userTenantDepartmentId == tenantDefaultStoreId
    );
  };

  return (
    <div className="view-document__title">
      <div className="view-document__title-number-wrapper">
        <H3Text text={selectedPurchaseRequest?.pr_number || 'N/A'} className="view-document__title-number" />
        {selectedPurchaseRequest?.status && <div className="view-document__title-status" style={{ backgroundColor: Helpers.getStatusColor(selectedPurchaseRequest?.status).color }}>
          {selectedPurchaseRequest?.status?.replaceAll('_', ' ')}
        </div>}
        {selectedPurchaseRequest?.fulfillment_status && <div className="view-document__title-status" style={{ backgroundColor: Helpers.getStatusColor(selectedPurchaseRequest?.fulfillment_status).color }}>
          {selectedPurchaseRequest?.fulfillment_status?.replaceAll('_', ' ')}
        </div>}
      </div>
      {!isQuickView && (
        <div className="view-document__title-actions">
          <div className="action-buttons">
            {Helpers.getPermission(Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.UPDATE, user) && selectedPurchaseRequest?.status !== 'COMPLETED' && (
              <H3Text
                text={(
                  <div onClick={() => {
                    if (selectedPurchaseRequest?.reference_purchase_orders?.length > 0 || selectedPurchaseRequest?.reference_stock_transfers?.length > 0 || selectedPurchaseRequest?.reference_purchase_indents?.length > 0) {
                      notification.error({
                        message: 'This material request cannot be updated as it has linked purchase orders, stock transfers, purchase indents.',
                        description: 'Please delete all linked purchase orders, stock transfers and purchase indents first.',
                        placement: 'top',
                        duration: 6,
                      });
                    } else {
                      history.push(`/purchase/purchase-request/update/${selectedPurchaseRequest?.purchase_requisition_id}`);
                    }
                  }}
                  >
                    <EditOutlined />
                  </div>
                )}
                className="action-button hide__in-mobile"
              />
            )}
            <H3Text
              text={
                <FontAwesomeIcon icon={faPrint} style={{ fontSize: '16px', width: '35px', textAlign: 'center' }} />
              }
              onClick={() => handleDownload()}
              className="action-button"
            />
          </div>
          <div className="action-buttons">
            {Helpers.getPermission(Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.CREATE, user) && (
              <Tooltip
                placement="topLeft"
                title="Make a Copy"
              >
                <CopyOutlined
                  className="action-button"
                  style={{
                    justifyContent: 'center',
                    fontSize: '16px',
                  }}
                  onClick={() => {
                    history.push({
                      pathname: '/purchase/purchase-request/create',
                      state: { clonePrData: selectedPurchaseRequest?.purchase_requisition_id },
                    });
                  }}
                />
              </Tooltip>
            )}
            {['DRAFT'].includes(selectedPurchaseRequest?.status) && Helpers.getPermission(Helpers.permissionEntities.PURCHASE_REQUEST,
              Helpers.permissionTypes.CREATE, user) && (
              <Popconfirm
                placement="topRight"
                title="Are you sure you want to send this purchase order for approval?"
                onConfirm={() => {
                  setCurrentUpdate('SENT_FOR_APPROVAL');
                  updatePurchaseRequestStatus({
                    status: 'SENT_FOR_APPROVAL',
                    purchase_requisition_id: selectedPurchaseRequest.purchase_requisition_id,
                  }, () => {
                    getPurchaseRequestById(currentPrId, Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.READ)?.join(','), () => { });
                    setSendForApprovalConfirmation(false);
                    setCurrentUpdate('');
                  });
                }}
                okText="Yes"
                cancelText="No"
              >
                <H3Text
                  text={(
                    <div style={{ width: '180px', textAlign: 'center' }}>
                      {(updatePurchaseRequestStatusLoading && currentUpdate === 'SENT_FOR_APPROVAL')
                        ? <LoadingOutlined /> : (
                          <span>Confirm Material Request</span>
                        )}
                    </div>
                  )}
                  onClick={() => this.setState({ sendForApprovalConfirmation: true })}
                  className="action-button action-button-big"
                />
              </Popconfirm>
            )}
            {selectedPurchaseRequest?.status === 'ISSUED' && Helpers.getPermission(Helpers.permissionEntities.PURCHASE_REQUEST,
              Helpers.permissionTypes.CREATE, user) && (
              <Popconfirm
                placement="topRight"
                title="Are you sure you want to mark the material request as completed?"
                onConfirm={() => {
                  setCurrentUpdate('COMPLETED');
                  updatePurchaseRequestStatus({
                    status: 'COMPLETED',
                    purchase_requisition_id: selectedPurchaseRequest?.purchase_requisition_id,
                  }, () => {
                    getPurchaseRequestById(match.params.prId, Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.READ)?.join(','), () => { });
                    setCurrentUpdate('');
                  });
                }}
                okText="Yes"
                cancelText="No"
              >
                <H3Text
                  text={(
                    <div style={{ width: '50px', textAlign: 'center' }}>
                      {(updatePurchaseRequestStatusLoading && currentUpdate === 'COMPLETED')
                        ? <LoadingOutlined /> : (
                          <span>Close</span>
                        )}
                    </div>
                  )}
                  className="action-button action-button-big"

                />
              </Popconfirm>
            )}
            {selectedPurchaseRequest?.status?.toLowerCase() !== 'cancelled' && Helpers.getPermission(Helpers.permissionEntities.PURCHASE_REQUEST,
              Helpers.permissionTypes.CREATE, user) && (
              <Popconfirm
                placement="topRight"
                title="Are you sure you want to cancel?"
                onConfirm={() => {
                  if (selectedPurchaseRequest?.reference_purchase_orders?.filter((item) => !['CANCELLED'].includes(item.status))?.length > 0) {
                    notification.error({
                      message: 'This material request cannot be cancelled as it has linked purchase orders.',
                      description: 'Please cancel all open purchase orders first.',
                      placement: 'top',
                      duration: 6,
                    });
                  } else if (selectedPurchaseRequest?.reference_stock_transfers?.length) {
                    notification.error({
                      message: 'This material request cannot be cancelled as it has linked stock transfer.',
                      description: 'Please cancel all open stock transfer first.',
                      placement: 'top',
                      duration: 6,
                    });
                  } else if (selectedPurchaseRequest?.reference_purchase_indents?.filter((item) => !['CANCELLED'].includes(item?.status))?.length) {
                    notification.error({
                      message: 'This Material Request cannot be cancelled as it has linked Purchase Indents.',
                      description: 'Please cancel all open Purchase Indents first.',
                      placement: 'top',
                      duration: 6,
                    });
                  } else {
                    setCurrentUpdate('CANCELLED');
                    updatePurchaseRequestStatus({
                      status: 'CANCELLED',
                      purchase_requisition_id: selectedPurchaseRequest?.purchase_requisition_id,
                    }, () => {
                      getPurchaseRequestById(match.params.prId, Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.READ)?.join(','), () => { });
                      setCurrentUpdate('');
                    });
                  }
                }}
                okText="Yes"
                cancelText="No"
              >
                <H3Text
                  text={(
                    <div style={{ width: '50px', textAlign: 'center' }}>
                      {(updatePurchaseRequestStatusLoading && currentUpdate === 'CANCELLED')
                        ? <LoadingOutlined /> : (
                          <span>Cancel</span>
                        )}
                    </div>
                  )}
                  className="action-button action-button-big"

                />
              </Popconfirm>
            )}
            {Helpers.getPermission(Helpers.permissionEntities.PURCHASE_REQUEST,
              Helpers.permissionTypes.DELETE, user) && selectedPurchaseRequest?.status?.toLowerCase() === 'cancelled' && (
              <Popconfirm
                placement="topRight"
                title="Are you sure you want to delete the purchase order?"
                onConfirm={() => {
                  if (selectedPurchaseRequest?.reference_purchase_orders?.length > 0) {
                    notification.error({
                      message: 'This material request cannot be deleted as it has linked purchase orders.',
                      description: 'Please delete all linked purchase orders first.',
                      placement: 'top',
                      duration: 6,
                    });
                  } else {
                    deletePurchaseRequest({
                      tenant_id: selectedPurchaseRequest?.tenant_id,
                      purchase_requisition_id: selectedPurchaseRequest.purchase_requisition_id,
                    }, () => {
                      history.push('/purchase/purchase-request');
                    });
                  }
                }}
                okText="Yes"
                cancelText="No"
              >
                <H3Text
                  text={(
                    <div style={{ width: '50px', textAlign: 'center' }}>
                      {deletePurchaseRequestLoading ? <LoadingOutlined /> : (
                        <span>Delete</span>
                      )}
                    </div>
                  )}
                  className="action-button action-button-big"
                />
              </Popconfirm>
            )}
            {window.screen.width > 425 && selectedPurchaseRequest?.status === 'ISSUED' && (
              Helpers.getPermission(Helpers.permissionEntities.STOCK_TRANSFER, Helpers.permissionTypes.CREATE, user)
              || Helpers.getPermission(Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.CREATE, user)
              || (user?.tenant_info?.purchase_config?.addons?.request_for_quotation?.is_active && Helpers.getPermission(Helpers.permissionEntities.REQUEST_FOR_QUOTATION, Helpers.permissionTypes.CREATE, user))
              || (user?.tenant_info?.purchase_config?.sub_modules?.purchase_indent?.is_active && Helpers.getPermission(Helpers.permissionEntities.PURCHASE_INDENT, Helpers.permissionTypes.CREATE, user) && selectedPurchaseRequest?.status === 'ISSUED' && isIssuerDepartmentAccessible(selectedPurchaseRequest))
            ) && (
              <Dropdown
                overlay={(
                  <Menu>
                    {Helpers.getPermission(Helpers.permissionEntities.PURCHASE_ORDER,
                      Helpers.permissionTypes.CREATE, user) &&
                        user?.tenant_info?.purchase_config?.sub_modules?.purchase_request?.settings?.enable_po_creation_from_mr &&
                        selectedPurchaseRequest?.status === 'ISSUED' && isIssuerDepartmentAccessible(selectedPurchaseRequest) && (
                      <Menu.SubMenu
                        expandIcon={false}
                        className="hide__in-mobile no-arrow custom-submenu"
                        title={
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <div>+ Purchase Order</div>
                              {!user?.tenant_info?.purchase_config?.sub_modules?.purchase_order?.is_active && (
                                <Popconfirm
                                  placement="topRight"
                                  title="This feature is not accessible within your current plan. To use this feature, contact us."
                                  onConfirm={() => globalThis.Intercom('showNewMessage')}
                                  okText="Contact Us"
                                  cancelText="Cancel"
                                >
                                  <img className="barcode-restrict" style={{ marginLeft: '4px' }} src={Crown} alt="premium" />
                                </Popconfirm>
                              )}
                            </div>
                            {/* Arrow Icon */}
                            <CaretDownOutlined
                              style={{
                                marginLeft: '4px',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                transform: 'rotate(-90deg)',
                                transition: 'transform 0.2s ease'
                              }}
                              className="submenu-arrow"
                            />
                          </div>
                        }
                      >
                        <Menu.Item
                          key="single-vendor"
                          onClick={() =>
                            history.push(`/purchase/purchase-request/vendor-selection/${selectedPurchaseRequest?.purchase_requisition_id}`)
                          }
                        >
                              Multi Vendor PO
                        </Menu.Item>
                        <Menu.Item
                          key="multi-vendor"
                          onClick={() => {
                            const purchaseRequestData = selectedPurchaseRequest;
                            history.push({
                              pathname: '/purchase/purchase-orders/create',
                              state: { purchaseRequestData },
                            });
                          }}
                        >
                              Single Vendor PO
                        </Menu.Item>
                      </Menu.SubMenu>
                    )}
                    {Helpers.getPermission(Helpers.permissionEntities.STOCK_TRANSFER,
                      Helpers.permissionTypes.CREATE, user)
                        && selectedPurchaseRequest?.status === 'ISSUED'
                        && isIssuerDepartmentAccessible(selectedPurchaseRequest)
                        && user?.tenant_info?.purchase_config?.sub_modules?.purchase_request?.settings?.enable_st_creation_from_mr
                        && (
                          <Menu.Item>
                            <H3Text
                              text="+ Stock Transfer"
                              className="hide__in-mobile"
                              onClick={() => setShowNewStForm(true)}
                            />
                          </Menu.Item>
                        )}
                    {user?.tenant_info?.purchase_config?.addons?.request_for_quotation?.is_active && Helpers.getPermission(Helpers.permissionEntities.REQUEST_FOR_QUOTATION,
                      Helpers.permissionTypes.CREATE, user) && selectedPurchaseRequest?.status === 'ISSUED' && (
                      <Menu.Item>
                        <H3Text
                          text={(
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <div>
                                    + Create RFQ
                              </div>
                              {!user?.tenant_info?.purchase_config?.addons?.request_for_quotation?.is_active && (
                                <Popconfirm
                                  placement="topRight"
                                  title="This feature is not accessible within your current plan to use this feature contact us."
                                  onConfirm={() => globalThis.Intercom('showNewMessage')}
                                  okText="Contact Us"
                                  cancelText="Cancel"
                                >
                                  <img className="barcode-restrict" style={{ marginLeft: '4px' }} src={Crown} alt="premium" />
                                </Popconfirm>
                              )}
                            </div>
                          )}
                          className="hide__in-mobile"
                          onClick={() => setShowCreateRfqDrawer(true)}
                        />
                      </Menu.Item>
                    )}
                    {user?.tenant_info?.purchase_config?.sub_modules?.purchase_indent?.is_active &&
                        user?.tenant_info?.purchase_config?.sub_modules?.purchase_request?.settings?.enable_pi_creation_from_mr
                        && Helpers.getPermission(Helpers.permissionEntities.PURCHASE_INDENT, Helpers.permissionTypes.CREATE, user)
                        && selectedPurchaseRequest?.status === 'ISSUED'
                        && isIssuerDepartmentAccessible(selectedPurchaseRequest)
                        && (
                          <Menu.Item>
                            <H3Text
                              text={(
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <div>
                                    + Purchase Indent
                                  </div>
                                  {!user?.tenant_info?.purchase_config?.sub_modules?.purchase_indent?.is_active && (
                                    <Popconfirm
                                      placement="topRight"
                                      title="This feature is not accessible within your current plan to use this feature contact us."
                                      onConfirm={() => globalThis.Intercom('showNewMessage')}
                                      okText="Contact Us"
                                      cancelText="Cancel"
                                    >
                                      <img className="barcode-restrict" style={{ marginLeft: '4px' }} src={Crown} alt="premium" />
                                    </Popconfirm>
                                  )}
                                </div>
                              )}
                              className="hide__in-mobile"
                              onClick={() => setShowPIForm(true)}
                            />
                          </Menu.Item>
                        )}
                  </Menu>
                )}
                trigger={['click']}
                overlayStyle={{ width: '175px' }}
                placement="bottomLeft"
              >
                <H3Text
                  text={(
                    <div onClick={(e) => e.preventDefault()}>
                        More
                      <CaretDownOutlined />
                    </div>
                  )}
                  className="action-button action-button-big no-right-border"
                />
              </Dropdown>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewPrHeader;
